import { useRef } from "react";

import { styled } from "styled-components";
import { xyAdjust } from "theme";

import FnrIconButton from "UI/FnrIconButton";
import FnrOpacityToggle from "UI/FnrOpacityToggle";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

import useIsHoverFocused from "Utilities/Hooks/useIsHoverFocused";

import { useFnrPencilEditInputContext } from "../FnrPencilEditInput";

import MoreMenu from "./MoreMenu";

const SDiv = styled("div")`
  ${xyAdjust}
`;
const EditButton = () => {
  const {
    setIsEditing,
    isEditing,
    disabled,
    containerIsHoverFocused,
    labelSuffix,
    alwaysShowPencil,
    iconButtonProps,
    onEdit,
    editButtonXAdjust,
    editButtonRef,
    moreMenuOpen,
  } = useFnrPencilEditInputContext();

  const popoverRef = useRef();
  const isHoverFocused = useIsHoverFocused(editButtonRef, popoverRef);
  const handleClick = () => {
    setIsEditing(true);
    if (onEdit) onEdit();
  };

  const show =
    Boolean(isHoverFocused || containerIsHoverFocused || alwaysShowPencil) &&
    !isEditing;

  const showMoreButtons =
    moreMenuOpen ||
    (Boolean(isHoverFocused || containerIsHoverFocused) && !isEditing);

  if (disabled) return null;

  return (
    <SDiv $xAdjust={editButtonXAdjust}>
      <FnrHorizontalGap gap={2}>
        <FnrOpacityToggle show={show} scale>
          <FnrIconButton
            ref={editButtonRef}
            size="sm"
            aria-label={`edit-${labelSuffix}`}
            icon="pencil fas"
            onClick={handleClick}
            {...iconButtonProps}
          />
        </FnrOpacityToggle>
        <FnrOpacityToggle show={showMoreButtons} scale>
          <MoreMenu />
        </FnrOpacityToggle>
      </FnrHorizontalGap>
    </SDiv>
  );
};

export default EditButton;
